<template>
  <!--begin::Card-->
  <div class="card">
    <!--begin::Card Body-->
    <div class="card-body p-10 p-lg-15">
      <!--begin::Accordion-->
      <div
        class="accordion accordion-flush accordion-icon-toggle"
        id="kt_accordion_2"
      >
        <!--begin::Item-->
        <div class="mb-5">
          <!--begin::Header-->
          <div
            class="accordion-header py-3 d-flex"
            data-bs-toggle="collapse"
            data-bs-target="#kt_accordion_2_item_8"
          >
            <span class="accordion-icon">
              <span class="svg-icon svg-icon-3">
                <inline-svg src="media/icons/duotone/Navigation/Right-2.svg" />
              </span>
            </span>
            <h3 class="fs-4 text-gray-800 fw-bold mb-0 ms-4">
              {{ themeName }} v8.0.17 - 7 July, 2021
            </h3>
          </div>
          <!--end::Header-->

          <!--begin::Body-->
          <div
            id="kt_accordion_2_item_8"
            class="fs-6 collapse show ps-10"
            data-bs-parent="#kt_accordion_2"
          >
            <h3 class="fs-6 fw-bolder mb-1">New:</h3>
            <ul class="py-2">
              <li class="py-2">
                Added general modal pages
                <a
                  href="https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/pages/profile/activity"
                  >Preview</a
                >
              </li>
            </ul>
            <h3 class="fs-6 fw-bolder mb-1">Fixes:</h3>
            <ul class="py-2">
              <li class="py-2">
                Fixed DrawerMessanger initialization bug
                <a
                  href="https://preview.keenthemes.com/metronic8/vue/demo1/#/apps/chat/drawer-chat"
                  >Preview</a
                >
              </li>
            </ul>
          </div>
          <!--end::Body-->
        </div>
        <!--end::Item-->

        <!--begin::Item-->
        <div class="mb-5">
          <!--begin::Header-->
          <div
            class="accordion-header py-3 d-flex collapsed"
            data-bs-toggle="collapse"
            data-bs-target="#kt_accordion_2_item_7"
          >
            <span class="accordion-icon">
              <span class="svg-icon svg-icon-3">
                <inline-svg src="media/icons/duotone/Navigation/Right-2.svg" />
              </span>
            </span>
            <h3 class="fs-4 text-gray-800 fw-bold mb-0 ms-4">
              {{ themeName }} v8.0.16 - 28 June, 2021
            </h3>
          </div>
          <!--end::Header-->

          <!--begin::Body-->
          <div
            id="kt_accordion_2_item_7"
            class="fs-6 collapse ps-10"
            data-bs-parent="#kt_accordion_2"
          >
            <h3 class="fs-6 fw-bolder mb-1">New:</h3>
            <ul class="py-2">
              <li class="py-2">
                Added general modal pages
                <ul class="py-2">
                  <li class="py-2">
                    Invite Friends
                    <a
                      href="https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/modals/general/invite-friends"
                      >Preview</a
                    >
                  </li>
                  <li class="py-2">
                    View Users
                    <a
                      href="https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/modals/general/view-user"
                      >Preview</a
                    >
                  </li>
                  <li class="py-2">
                    Upgrade Plan
                    <a
                      href="https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/modals/general/upgrade-plan"
                      >Preview</a
                    >
                  </li>
                  <li class="py-2">
                    Share & Earn
                    <a
                      href="https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/modals/general/share-and-earn"
                      >Preview</a
                    >
                  </li>
                </ul>
              </li>
              <li class="py-2">
                Added form modal pages
                <ul class="py-2">
                  <li class="py-2">
                    New Targer
                    <a
                      href="https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/modals/forms/new-target"
                      >Preview</a
                    >
                  </li>
                  <li class="py-2">
                    New Card
                    <a
                      href="https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/modals/forms/new-card"
                      >Preview</a
                    >
                  </li>
                  <li class="py-2">
                    New Address
                    <a
                      href="https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/modals/forms/new-address"
                      >Preview</a
                    >
                  </li>
                  <li class="py-2">
                    Create API Key
                    <a
                      href="https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/modals/forms/create-api-key"
                      >Preview</a
                    >
                  </li>
                </ul>
              </li>
              <li class="py-2">
                Added wizard modal pages
                <ul class="py-2">
                  <li class="py-2">
                    Two Factor Auth
                    <a
                      href="https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/modals/wizards/two-factor-auth"
                      >Preview</a
                    >
                  </li>
                  <li class="py-2">
                    Create App
                    <a
                      href="https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/modals/wizards/create-app"
                      >Preview</a
                    >
                  </li>
                  <li class="py-2">
                    Create Account
                    <a
                      href="https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/modals/wizards/create-account"
                      >Preview</a
                    >
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <!--end::Body-->
        </div>
        <!--end::Item-->

        <!--begin::Item-->
        <div class="mb-5">
          <!--begin::Header-->
          <div
            class="accordion-header py-3 d-flex collapsed"
            data-bs-toggle="collapse"
            data-bs-target="#kt_accordion_2_item_6"
          >
            <span class="accordion-icon">
              <span class="svg-icon svg-icon-3">
                <inline-svg src="media/icons/duotone/Navigation/Right-2.svg" />
              </span>
            </span>
            <h3 class="fs-4 text-gray-800 fw-bold mb-0 ms-4">
              {{ themeName }} v8.0.15 - 17 June, 2021
            </h3>
          </div>
          <!--end::Header-->

          <!--begin::Body-->
          <div
            id="kt_accordion_2_item_6"
            class="fs-6 collapse ps-10"
            data-bs-parent="#kt_accordion_2"
          >
            <h3 class="fs-6 fw-bolder mb-1">New:</h3>
            <ul class="py-2">
              <li class="py-2">
                Added widgets pages
                <a
                  href="https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/widgets/lists"
                  >Preview</a
                >
              </li>
            </ul>
          </div>
          <!--end::Body-->
        </div>
        <!--end::Item-->

        <!--begin::Item-->
        <div class="mb-5">
          <!--begin::Header-->
          <div
            class="accordion-header py-3 d-flex collapsed"
            data-bs-toggle="collapse"
            data-bs-target="#kt_accordion_2_item_5"
          >
            <span class="accordion-icon">
              <span class="svg-icon svg-icon-3">
                <inline-svg src="media/icons/duotone/Navigation/Right-2.svg" />
              </span>
            </span>
            <h3 class="fs-4 text-gray-800 fw-bold mb-0 ms-4">
              {{ themeName }} v8.0.14 - 4 June, 2021
            </h3>
          </div>
          <!--end::Header-->

          <!--begin::Body-->
          <div
            id="kt_accordion_2_item_5"
            class="fs-6 collapse ps-10"
            data-bs-parent="#kt_accordion_2"
          >
            <h3 class="fs-6 fw-bolder mb-1">New:</h3>
            <ul class="py-2">
              <li class="py-2">
                Added vue-i18n plugin and menu translation example. Update
                languge in profile dropdown.
                <a
                  href="https://preview.keenthemes.com/metronic8/vue/demo1/#/dashboard"
                  >Preview</a
                >
              </li>
            </ul>
          </div>
          <!--end::Body-->
        </div>
        <!--end::Item-->

        <!--begin::Item-->
        <div class="mb-5">
          <!--begin::Header-->
          <div
            class="accordion-header py-3 d-flex collapsed"
            data-bs-toggle="collapse"
            data-bs-target="#kt_accordion_2_item_4"
          >
            <span class="accordion-icon">
              <span class="svg-icon svg-icon-3">
                <inline-svg src="media/icons/duotone/Navigation/Right-2.svg" />
              </span>
            </span>
            <h3 class="fs-4 text-gray-800 fw-bold mb-0 ms-4">
              {{ themeName }} v8.0.13 - 9 June, 2021
            </h3>
          </div>
          <!--end::Header-->

          <!--begin::Body-->
          <div
            id="kt_accordion_2_item_4"
            class="fs-6 collapse ps-10"
            data-bs-parent="#kt_accordion_2"
          >
            <h3 class="fs-6 fw-bolder mb-1">New:</h3>
            <ul class="py-2">
              <li class="py-2">
                Added private chat page.
                <a
                  href="https://preview.keenthemes.com/metronic8/vue/demo1/#/apps/chat/private-chat"
                  >Preview</a
                >
              </li>
              <li class="py-2">
                Added group chat page.
                <a
                  href="https://preview.keenthemes.com/metronic8/vue/demo1/#/apps/chat/group-chat"
                  >Preview</a
                >
              </li>
              <li class="py-2">
                Added drawer chat page.
                <a
                  href="https://preview.keenthemes.com/metronic8/vue/demo1/#/apps/chat/drawer-chat"
                  >Preview</a
                >
              </li>
            </ul>
          </div>
          <!--end::Body-->
        </div>
        <!--end::Item-->

        <!--begin::Item-->
        <div class="mb-5">
          <!--begin::Header-->
          <div
            class="accordion-header py-3 d-flex collapsed"
            data-bs-toggle="collapse"
            data-bs-target="#kt_accordion_2_item_3"
          >
            <span class="accordion-icon">
              <span class="svg-icon svg-icon-3">
                <inline-svg src="media/icons/duotone/Navigation/Right-2.svg" />
              </span>
            </span>
            <h3 class="fs-4 text-gray-800 fw-bold mb-0 ms-4">
              {{ themeName }} v8.0.12 - 28 May, 2021
            </h3>
          </div>
          <!--end::Header-->

          <!--begin::Body-->
          <div
            id="kt_accordion_2_item_3"
            class="fs-6 collapse ps-10"
            data-bs-parent="#kt_accordion_2"
          >
            <h3 class="fs-6 fw-bolder mb-1">New:</h3>
            <ul class="py-2">
              <li class="py-2">
                Added wizard demo pages.
                <a
                  href="https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/pages/wizards/vertical"
                  >Preview</a
                >
              </li>
            </ul>
          </div>
          <!--end::Body-->
        </div>
        <!--end::Item-->

        <!--begin::Item-->
        <div class="mb-5">
          <!--begin::Header-->
          <div
            class="accordion-header py-3 d-flex collapsed"
            data-bs-toggle="collapse"
            data-bs-target="#kt_accordion_2_item_2"
          >
            <span class="accordion-icon">
              <span class="svg-icon svg-icon-3">
                <inline-svg src="media/icons/duotone/Navigation/Right-2.svg" />
              </span>
            </span>
            <h3 class="fs-4 text-gray-800 fw-bold mb-0 ms-4">
              {{ themeName }} v8.0.11 - 26 May, 2021
            </h3>
          </div>
          <!--end::Header-->

          <!--begin::Body-->
          <div
            id="kt_accordion_2_item_2"
            class="fs-6 collapse ps-10"
            data-bs-parent="#kt_accordion_2"
          >
            <h3 class="fs-6 fw-bolder mb-1">New:</h3>
            <ul class="py-2">
              <li class="py-2">
                Setup theme skeleton doc.
                <a
                  href="https://preview.keenthemes.com/metronic8/vue/demo1/#/documentation/setup-theme-skeleton"
                  >Preview</a
                >
              </li>
            </ul>
            <h3 class="fs-6 fw-bolder mb-1">Update:</h3>
            <ul class="py-2">
              <li class="py-2">
                Updated sign-in form buttons.
                <a
                  href="https://preview.keenthemes.com/metronic8/vue/demo1/#/sign-in"
                  >Preview</a
                >
              </li>
            </ul>
          </div>
          <!--end::Body-->
        </div>
        <!--end::Item-->

        <!--begin::Item-->
        <div class="mb-5">
          <!--begin::Header-->
          <div
            class="accordion-header py-3 d-flex collapsed"
            data-bs-toggle="collapse"
            data-bs-target="#kt_accordion_2_item_1"
          >
            <span class="accordion-icon">
              <span class="svg-icon svg-icon-3">
                <inline-svg src="media/icons/duotone/Navigation/Right-2.svg" />
              </span>
            </span>
            <h3 class="fs-4 text-gray-800 fw-bold mb-0 ms-4">
              {{ themeName }} v8.0.10 - 21 May, 2021
            </h3>
          </div>
          <!--end::Header-->

          <!--begin::Body-->
          <div
            id="kt_accordion_2_item_1"
            class="fs-6 collapse ps-10"
            data-bs-parent="#kt_accordion_2"
          >
            <ul class="py-2">
              <li class="py-2">Initial release.</li>
            </ul>
          </div>
          <!--end::Body-->
        </div>
        <!--end::Item-->
      </div>
      <!--end::Accordion-->
    </div>
    <!--end::Card Body-->
  </div>
  <!--end::Card-->
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { themeName } from "@/core/helpers/documentation";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";

export default defineComponent({
  name: "changelog",
  components: {},
  setup() {
    onMounted(() => {
      setCurrentPageTitle("Changelog");
    });

    return {
      themeName
    };
  }
});
</script>
